
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"display":"inline-block","vertical-align":"middle","overflow":"visible"},style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","width":"16","height":"16","fill":"none","stroke":"#2c3e50","stroke-width":"3","style":"display:inline-block;vertical-align:middle;overflow:visible;"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 2.5 L16 2.5"}}),_c('path',{attrs:{"d":"M0 8 L16 8"}}),_c('path',{attrs:{"d":"M0 13.5 L16 13.5"}})])
          )
        }
      }
    